/* eslint-disable react/react-in-jsx-scope */
import {
  createBrowserRouter,
  RouterProvider,
  Outlet,
  Navigate,
} from "react-router-dom";
import Login from "../pages/Auth/login";
import Layout from "../components/Layout";
import Dashboard from "../pages/Dashboard";
import UserManagement, { AddUser, EditUser } from "../pages/UserManagement";
import IFCProcessing from "../pages/IFCProcessing";
import ProjectManagement from "../pages/ProjectManagement";
import AddProjectPage from "../pages/AddProjectPage";
import ProjectFormPage from "../pages/ProjectManagement/ProjectFormPage";
import ViewProjectPage from "../pages/ViewProjectPage";
import Help from "../pages/Help";
import Reports from "../pages/Reports";
import TrackAudits from "../pages/TrackAudits";
import UploadSuccess from "../pages/UploadSuccess";
import ManageAccount from "../pages/ManageAccount";
import { ProtectedRoute } from "./protectedRoute";
import { TypeRestrictedRoute } from "./typeRestrictedRoute";
import { IdleTimeoutWrapper } from "../components/IdleTimeoutWrapper";
export const router = createBrowserRouter([
  {
    path: "/",
    children: [
      {
        path: "/",
        element: (
          <ProtectedRoute>
            <IdleTimeoutWrapper>
              <Layout>
                <Outlet />
              </Layout>
            </IdleTimeoutWrapper>
          </ProtectedRoute>
        ),
        children: [
          {
            index: true,
            element: <Navigate to="/dashboard" replace />,
          },
          {
            path: "dashboard",
            element: (
              <TypeRestrictedRoute allowedTypes={["0", "2"]}>
                <Dashboard />
              </TypeRestrictedRoute>
            ),
          },
          {
            path: "user-management",
            element: (
              <TypeRestrictedRoute allowedTypes={["0"]}>
                <UserManagement />
              </TypeRestrictedRoute>
            ),
          },
          {
            path: "user-management/add",
            element: (
              <TypeRestrictedRoute allowedTypes={["0"]}>
                <AddUser />
              </TypeRestrictedRoute>
            ),
          },
          {
            path: "user-management/edit/:id",
            element: (
              <TypeRestrictedRoute allowedTypes={["0"]}>
                <EditUser />
              </TypeRestrictedRoute>
            ),
          },
          {
            path: "ifc-processing",
            element: (
              <TypeRestrictedRoute allowedTypes={["0", "2"]}>
                <IFCProcessing />
              </TypeRestrictedRoute>
            ),
          },
          {
            path: "ifc-processing/:id",
            element: (
              <TypeRestrictedRoute allowedTypes={["0", "2"]}>
                <IFCProcessing />
              </TypeRestrictedRoute>
            ),
          },
          {
            path: "project-management",
            element: (
              <TypeRestrictedRoute allowedTypes={["0", "2"]}>
                <ProjectManagement />
              </TypeRestrictedRoute>
            ),
          },
          {
            path: "project-management/add",
            element: (
              <TypeRestrictedRoute allowedTypes={["0", "2"]}>
                <AddProjectPage />
              </TypeRestrictedRoute>
            ),
          },
          {
            path: "project-management/edit/:id",
            element: (
              <TypeRestrictedRoute allowedTypes={["0", "2"]}>
                <ProjectFormPage />
              </TypeRestrictedRoute>
            ),
          },
          {
            path: "project-management/view/:id",
            element: (
              <TypeRestrictedRoute allowedTypes={["0", "2"]}>
                <ViewProjectPage />
              </TypeRestrictedRoute>
            ),
          },
          {
            path: "help",
            element: (
              <TypeRestrictedRoute allowedTypes={["0", "2"]}>
                <Help />
              </TypeRestrictedRoute>
            ),
          },
          {
            path: "reports",
            element: (
              <TypeRestrictedRoute allowedTypes={["0", "2"]}>
                <Reports />
              </TypeRestrictedRoute>
            ),
          },
          {
            path: "track-audits",
            element: (
              <TypeRestrictedRoute allowedTypes={["0", "2"]}>
                <TrackAudits />
              </TypeRestrictedRoute>
            ),
          },
          {
            path: "upload-success/:projectId",
            element: <UploadSuccess />,
          },
          {
            path: "upload-success",
            element: <Navigate to="/project-management" replace />,
          },
          {
            path: "manage-account",
            element: (
              <TypeRestrictedRoute allowedTypes={["0", "2"]}>
                <ManageAccount />
              </TypeRestrictedRoute>
            ),
          },

        ],
      },
      {
        path: "login",
        element: <Login />,
      },
      {
        path: "*",
        element: <Navigate to="/dashboard" />,
      },
    ],
  },
]);

export const AppRouter: React.FC = () => {
  return <RouterProvider router={router} />;
};
